import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Service.js";

HSN.Service.AddressService = function () {

};
HSN.Service.AddressService.prototype = {
    GetAddressManagementWidget: function (data, config) {
        this._get('/address-management/get', data, config);
    },
    GetAddAddressForm: function (data, config) {
        this._get('/address-management/add-edit-address', data, config);
    },
    GetEditAddressForm: function (addressIdentity, data, config) {
        this._get('/address-management/add-edit-address/' + addressIdentity, data, config);
    },
    GetAddressList: function (data, config) {
        this._get('/address-management/address-list', data, config);
    },
    GetCityStateFromZip: function (data, config) {
        this._send('/address-management/city-state-from-zip', data, config);
    },
    RemoveAddress: function (data, config) {
        this._send('/address-management/remove-address', data, config);
    },
    ValidateAddress: function (data, config) {
        this._send('/address-management/validate-address', data, config);
    },
    AddEditAddressSave: function (data, config) {
        this._send('/address-management/add-edit-address-save', data, config);
    },
    SelectAddress: function (data, config) {
        this._send('/address-management/select-address', data, config);
    },

    _send: function (url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'POST',
                data: data,
                context: this,
                dataType: 'json',
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function () {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback));
                    }
                    else if (config.callback) {
                        config.callback.call((config.scope || config.callback), true);
                    }
                }
            }
        );
    },

    _get: function (url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'GET',
                data: data,
                context: this,
                dataType: 'html',
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function (xhr, status) {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback), status);
                    }
                }
            }
        );
    }
};


// WEBPACK FOOTER //
// ./assets/js/HSN/Service/AddressService.js